import React from 'react';
import { Bell, ChevronRight } from 'lucide-react';
import type { AvisoUc } from '../../../../src/lib/avisosUc';

// Faixa de uma linha no topo do modal da UC, visível em qualquer aba. Antes a lista
// inteira ficava ali e empurrava o conteúdo da aba (24 cards na UC 9628901272).
interface Props {
    ativos: AvisoUc[];
    onVer: () => void;
}

const MOSTRAR = 2;
const resumo = (texto: string) => {
    const linha = texto.replace(/\s+/g, ' ').trim();
    return linha.length > 70 ? `${linha.slice(0, 70)}…` : linha;
};

const AvisosUcFaixa: React.FC<Props> = ({ ativos, onVer }) => {
    if (ativos.length === 0) return null;
    const resto = ativos.length - MOSTRAR;
    return (
        <button
            type="button"
            onClick={onVer}
            data-faixa-avisos
            className="mt-3 w-full flex items-center gap-2 px-3 py-2 rounded-lg bg-orange-50 dark:bg-orange-900/15 border border-orange-200 dark:border-orange-800/40 text-left hover:bg-orange-100/70 dark:hover:bg-orange-900/25 transition-colors"
        >
            <Bell size={16} className="text-orange-600 dark:text-orange-400 shrink-0" />
            <span className="text-sm font-bold text-orange-700 dark:text-orange-300 shrink-0">
                {ativos.length} {ativos.length === 1 ? 'aviso ativo' : 'avisos ativos'}:
            </span>
            <span className="text-sm text-gray-700 dark:text-gray-200 truncate min-w-0">
                {ativos.slice(0, MOSTRAR).map(a => `${resumo(a.descricao)}${a.criado_por_nome ? ` (${a.criado_por_nome.split(' ')[0]})` : ''}`).join(' · ')}
                {resto > 0 ? ` · e mais ${resto}` : ''}
            </span>
            <span className="ml-auto text-sm font-semibold text-primary shrink-0 flex items-center">
                Ver avisos <ChevronRight size={16} />
            </span>
        </button>
    );
};

export default AvisosUcFaixa;
